// Global event bus (PubSub)
// Used to notify components that related entities have changed.
// Payloads are fully typed: an emitter cannot send a shape the listeners
// don't expect, and listeners get real types instead of `any`.
class EventBusImpl {
    constructor() {
        this.listeners = {};
    }
    /**
     * Subscribe to an event
     * @param event Event type
     * @param listener Handler
     * @returns Unsubscribe function
     */
    on(event, listener) {
        let listeners = this.listeners[event];
        if (!listeners) {
            // @ts-ignore -- TS cannot prove Set<EventBusListener<E>> matches the mapped listener type
            listeners = new Set();
            this.listeners[event] = listeners;
        }
        listeners.add(listener);
        return () => this.off(event, listener);
    }
    /** Unsubscribe from an event */
    off(event, listener) {
        const listeners = this.listeners[event];
        if (!listeners)
            throw new Error();
        listeners.delete(listener);
    }
    /**
     * Emit an event
     * @param event Event type
     * @param payload Event data
     */
    emit(event, payload) {
        const listeners = this.listeners[event];
        if (!listeners)
            return;
        listeners.forEach(listener => {
            // @ts-ignore -- payload type is guaranteed by the emit signature
            listener(payload);
        });
    }
}
export const EventBus = new EventBusImpl();
